<section class="section banner">
    <!-- Video de fondo -->
    <video
        muted
        defaultmuted
        loop
        playsinline
        preload="none"
        disablepictureinpicture
        class="banner-video">
        <source src="assets/images/banner-video2.mp4" type="video/mp4">
        <!-- Fallback para navegadores que no soportan el video -->
        Tu navegador no soporta videos HTML5.
    </video>

    <!-- Overlay para oscurecer el video -->
    <div class="banner-overlay"></div>

    <div class="container">
        <div class="section-box-banner">
            <div class="content">
                <div class="banner-pretitle">
                    <h1>{{"Banner.Pretitle" | translate}}</h1>
                </div>
                <div class='banner-title'>
                    <h2 class="banner-name">DevSense (Pty) Ltd.</h2>
                    <h3 class="banner-subtitle">A Development Company</h3>
                </div>
                <!-- <div class='banner-description' [innerHTML]=companySummary>

                </div> -->
                <div class='banner-description' >
                    <p [innerHTML]='"Banner.Description"  | translate'></p>
                </div>
            </div>
            <div class="div-btn-banner">
                <app-dynamic-button
                    [text]='"Banner.ActionBtn" | translate'
                    href="mailto:info@devsense.co.za"
                    target="_blank"
                    analyticsEvent="click_send_mail"
                    analyticsCategory="banner"
                    analyticsLabel="email"
                    variant="primary">
                </app-dynamic-button>
            </div>
        </div>
    </div>


</section>
